<template>
  <div>

 <b-modal @hidden="resetModal" size="md" id="productModal" title="Create Product" ok-title="Create" @ok="handleOk" ref="productModal">


        <b-form ref="productForm" @submit.prevent="handleSubmit">
          <b-form-row>
            <b-col>
              <b-form-group label="Product Title" label-for="productTitle">
                <b-form-input id="productTitle" type="text" v-model="productForm.productTitle" placeholder="Product Title">
                </b-form-input>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group id="availGroup" label="Available" label-for="availSelect">
        <b-form-select
          id="availSelect"
          v-model="productForm.avail"
          :options="availOpts"
        ></b-form-select>
      </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>

              <b-form-group label="Price" label-for="price">
                <b-form-input id="price" type="number" v-model.number="productForm.price">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>


              <b-form-group label="Total Stock" label-for="totalStock">
                <b-form-input id="totalStock" type="number" v-model.number="productForm.totalStock">
                </b-form-input>
              </b-form-group>

              <b-form-group label="Product Image" label-for="productImage">
                <b-form-input id="productImage" type="text" v-model.number="productForm.productImage">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <button type="submit" ref="submitBtn" v-show="false">Create</button>

        </b-form>

      </b-modal>
    </div>
    </template>
    <script>
    export default {
      name: 'ProductModal',
      computed: {
        products() {
          return this.$store.state.products.products
        }
      },
      data() {
        return {
          availOpts: [
            true,false
          ],
          productForm: {
          avail: true, //default to true
          productTitle: '',
          price: null,
          totalStock: null,
          productImage: null,
        }
        }
      },
      methods: {
        handleOk(e){
          // console.log('handleOk called')
          e.preventDefault()
          this.$refs.submitBtn.click()
        },
        handleSubmit(e){
          console.log(`createProduct form submitted`)
          let {productTitle,price,totalStock} = this.productForm
          if(!productTitle || !price || !totalStock) return console.error('incomplete form')
          console.log(`creating product ${productTitle} with stock ${totalStock} and price ${price}`)
          this.$store.dispatch('products/createProduct',this.productForm)
          this.$refs.productForm.reset()
          this.$nextTick(() => {
        this.$refs.productModal.hide()
      })

    },
    resetModal() {
      this.productForm = {
        avail: true, //default to true
        productTitle: '',
        price: null,
        totalStock: null,
      }
    }
  }
}
    </script>
